import woodenfloorData from "../../data/wooden-flooringData";
import ServiceHero from "../../components/ServiceHero/ServiceHero";
import ServiceOverview from "../../components/ServiceOverview/ServiceOverview";
import ServiceBenefits from "../../components/ServiceBenefits/ServiceBenefits";
import ConstructionProcess from "../../components/ConstructionProcess/ConstructionProcess";
import TechnicalSpecs from "../../components/TechnicalSpecs/TechnicalSpecs";
import ServiceGallery from "../../components/ServiceGallery/ServiceGallery";
import WhyChooseService from "../../components/WhyChooseService/WhyChooseService";
import ServiceFAQ from "../../components/ServiceFAQ/ServiceFAQ";
import RelatedServices from "../../components/RelatedServices/RelatedServices";
import ServiceCTA from "../../components/ServiceCTA/ServiceCTA";

const WoodenFlooring = () => {
  return (
    <>
      <ServiceHero data={woodenfloorData} />

      <ServiceOverview data={woodenfloorData} />

      <ServiceBenefits data={woodenfloorData} />

      <ConstructionProcess />

      <TechnicalSpecs data={woodenfloorData} />

      <ServiceGallery data={woodenfloorData} />

      <WhyChooseService data={woodenfloorData} />

      <ServiceFAQ faqs={woodenfloorData.faqs} />

      <RelatedServices data={woodenfloorData} />

      <ServiceCTA data={woodenfloorData} />
    </>
  );
};

export default WoodenFlooring;
